import { render, staticRenderFns } from "./IncomeTreeTable.vue?vue&type=template&id=3fa86534&scoped=true&"
import script from "./IncomeTreeTable.vue?vue&type=script&lang=ts&"
export * from "./IncomeTreeTable.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeTreeTable.vue?vue&type=style&index=0&id=3fa86534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa86534",
  null
  
)

export default component.exports